import axios from "axios";

const AxiosInstance = axios.create({
  baseURL: "https://bxge5lc56l.execute-api.ap-south-1.amazonaws.com/Prod",
});

// Dev-only fallback so API calls work without logging in locally - same
// REACT_APP_DEV_TOKEN as App.js reads (set it in .env.local, gitignored,
// never committed). This used to be its own separate hardcoded JWT
// literal here, independent of App.js's - a real (since-expired) token
// that was live and already pushed to origin/main before being caught.
// Never relied on when localStorage has a real token, and never set in
// a production build.
const LOCAL_DEV_TOKEN =
  process.env.NODE_ENV !== "production" ? process.env.REACT_APP_DEV_TOKEN : null;

AxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || LOCAL_DEV_TOKEN;
  if (token) {
    config.headers.tymeplusjwt = token;
  } else {
    console.warn("AxiosInstance: no auth token available, request will be sent without tymeplusjwt");
  }
  return config;
});

export default AxiosInstance;